import React, { useContext } from 'react';
import noDataStyles from './NoDataPage.style';
import { Grid, Box, InputLabel } from '@material-ui/core';
import noData from 'assets/img/no_data.png';
import {
	NO_REPORTS_SHARED,
	NO_REPORTS_PROJECT,
	NO_REPORTS_PROJECT_BASIC,
	WELCOME_TEXT_TWO,
	PROJECTS,
	BASIC
} from 'constants/constant';
import { useSelector } from 'react-redux';
import NewReportButton from '../../Shared/NewReportButton';
import { UserPortalContext } from 'context/appcontext';

function NoDataPage({ isSmallScreen }) {
	const classes = noDataStyles({ isSmallScreen });
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);

	const getTabValue = () => {
		if (tabValue === PROJECTS) {
			return NO_REPORTS_PROJECT;
		}

		return NO_REPORTS_SHARED;
	};

	return (
		<Box className={classes.containerHeight}>
			<Grid container className={classes.containerHeight}>
				<Grid className={classes.wrapper}>
					<Box display="flex" justifyContent="center">
						<img
							style={{ width: isSmallScreen ? '240px' : '325px' }}
							src={noData}
							alt="no-data-icon"></img>
					</Box>
					<Box display="flex" justifyContent="center" mt={2}>
						<InputLabel className={customerType == BASIC ? classes.textBasic : classes.textOne}>
							{customerType != BASIC ? getTabValue() : NO_REPORTS_PROJECT_BASIC}
						</InputLabel>
					</Box>
					{tabValue === PROJECTS && (
						<>
							{customerType != BASIC && (
								<Box display="flex" justifyContent="center" mt={2}>
									<InputLabel className={classes.textTwo}>{WELCOME_TEXT_TWO}</InputLabel>
								</Box>
							)}
							<Box display="flex" justifyContent="center" mt={4}>
								<NewReportButton />
							</Box>
						</>
					)}
				</Grid>
			</Grid>
		</Box>
	);
}

NoDataPage.propTypes = {};

export default NoDataPage;
